const DEFAULT_API_BASE_URL = '/api/v1'

export function normalizeApiBaseUrl(value = import.meta.env.VITE_API_BASE_URL) {
  const candidate = value?.trim() || DEFAULT_API_BASE_URL
  return `/${candidate.replace(/^\/+|\/+$/g, '')}`
}

export const apiBaseUrl = normalizeApiBaseUrl()
